export const FETCH_PROMOTION_PRODUCTS_REQUEST = 'FETCH_PROMOTION_PRODUCTS_REQUEST';
export const FETCH_PROMOTION_PRODUCTS_SUCCESS = 'FETCH_PROMOTION_PRODUCTS_SUCCESS';
export const FETCH_PROMOTION_PRODUCTS_FAILURE = 'FETCH_PROMOTION_PRODUCTS_FAILURE';

export const GET_PROMOTION_SEARCH_PRODUCTS = 'GET_PROMOTION_SEARCH_PRODUCTS';
export const GET_PROMOTION_SEARCH_PRODUCTS_SUCCESS = 'GET_PROMOTION_SEARCH_PRODUCTS_SUCCESS';
export const GET_PROMOTION_SEARCH_PRODUCTS_FAILURE = 'GET_PROMOTION_SEARCH_PRODUCTS_FAILURE';

export const FETCH_EMPTY_SEARCH_LIST = 'FETCH_EMPTY_SEARCH_LIST';
export const FETCH_SOP_PROFILE_REQUEST = 'FETCH_SOP_PROFILE_REQUEST';
export const FETCH_SOP_PROFILE_SUCCESS = 'FETCH_SOP_PROFILE_SUCCESS';
export const FETCH_SOP_PROFILE_FAILURE = 'FETCH_SOP_PROFILE_FAILURE';

export const GET_PROMOTION_SEARCH_KEYWORDS = 'FETCH_PROMOTION_SEARCH_KEYWORDS';
export const GET_PROMOTION_SEARCH_KEYWORDS_SUCCESS = 'FETCH_PROMOTION_SEARCH_KEYWORDS_SUCCESS';
export const GET_PROMOTION_SEARCH_KEYWORDS_FAILURE = 'FETCH_PROMOTION_SEARCH_KEYWORDS_FAILURE';

export const FETCH_REGULAR_PRODUCT_CATEGORY_REQUEST = 'FETCH_REGULAR_PRODUCT_CATEGORY_REQUEST';
export const FETCH_REGULAR_PRODUCT_CATEGORY_SUCCESS = 'FETCH_REGULAR_PRODUCT_CATEGORY_SUCCESS';
export const FETCH_REGULAR_PRODUCT_CATEGORY_FAILURE = 'FETCH_REGULAR_PRODUCT_CATEGORY_FAILURE';

export const FETCH_REGULAR_PRODUCT_SUB_CATEGORY_REQUEST = 'FETCH_REGULAR_PRODUCT_SUB_CATEGORY_REQUEST';
export const FETCH_REGULAR_PRODUCT_SUB_CATEGORY_SUCCESS = 'FETCH_REGULAR_PRODUCT_SUB_CATEGORY_SUCCESS';
export const FETCH_REGULAR_PRODUCT_SUB_CATEGORY_FAILURE = 'FETCH_REGULAR_PRODUCT_SUB_CATEGORY_FAILURE';

export const FETCH_REGULAR_PRODUCT_REQUEST = 'FETCH_REGULAR_PRODUCT_REQUEST';
export const FETCH_REGULAR_PRODUCT_SUCCESS = 'FETCH_REGULAR_PRODUCT_SUCCESS';
export const FETCH_REGULAR_PRODUCT_FAILURE = 'FETCH_REGULAR_PRODUCT_FAILURE';

export const GET_PRODUCT_DETAIL_REQUEST = 'FETCH_PRODUCT_DETAIL_REQUEST';
export const GET_PRODUCT_DETAIL_SUCCESS = 'FETCH_PRODUCT_DETAIL_SUCCESS';
export const GET_PRODUCT_DETAIL_FAILURE = 'FETCH_PRODUCT_DETAIL_FAILURE';
